var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "global-footer" }, [
    _c("div", { staticClass: "w-1200 mx-auto fz-12 copyright" }, [
      _c("span", { staticStyle: { "margin-right": "23px" } }, [
        _vm._v(_vm._s(_vm.config.copyright) + " ")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "beian" }, [
        _c("img", {
          attrs: {
            src:
              "https://co-image.qichacha.com/upload/chacha/img/20191206/1575615736779577.png",
            alt: ""
          }
        }),
        _vm._v("\n        \n       " + _vm._s(_vm.config.beian) + "\n      ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fef76b72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fef76b72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/Footer.vue
// module id = null
// module chunks = 